import script from "./list-game-slug.vue?vue&type=script&setup=true&lang=ts"
export * from "./list-game-slug.vue?vue&type=script&setup=true&lang=ts"

import "./list-game-slug.vue?vue&type=style&index=0&id=5a36b0a4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a36b0a4"]])

export default __exports__